import * as actionTypes from './actionsTypes';
import axios from '../../axios-vmou';

export const authStart = () => {
    return {
        type:actionTypes.AUTH_START
    };
};

export const authSuccess = (isfirst,token,username,eid,id) => {
    return {
        type:actionTypes.AUTH_SUCCESS,
        token:token,
        username:username,
        isFirst:isfirst,
        email:eid,
        userid:id
        };
};

export const authFail = (error) => {
    return {
        
        type:actionTypes.AUTH_FAIL,
        error:error
    };
};

export const logout = () => {
    localStorage.removeItem('token');
    //localStorage.removeItem('expirationDate');
    //localStorage.removeItem('email');
    //localStorage.removeItem('username');
    //localStorage.removeItem('userid');
    return {
        type:actionTypes.AUTH_LOGOUT
    };
};

const checkAuthTimeout = (expiresIn) => {
    return dispatch => {
        setTimeout(() => {
            dispatch(logout());
        },expiresIn * 1000)
    }
}

export const auth = (eid, pwd) => {
    return async dispatch => {
        dispatch(authStart());
        const authData = {
            email:eid,
            password:pwd
        }
        var authOptions = {
            method: 'POST',
            url: '/auth',
            data: authData,
            json: true
        };
        axios(authOptions)
        .then(response => {
            //const expirationDate = new Date(new Date().getTime()+response.data.expiresIn*1000);
            localStorage.setItem('token',response.data.token);
            //localStorage.setItem('expirationDate',expirationDate);
            //localStorage.setItem('userId',response.data.userId);
            //localStorage.setItem('username',response.data.username);
            //localStorage.setItem('userid',response.data.userid);
            dispatch(authSuccess(response.data.isFirst,response.data.token, response.data.name, response.data.email,response.data.userId))
            //dispatch(checkAuthTimeout(response.data.expiresIn))
        })
        .catch((error) => {
            dispatch(authFail(error));
        });
    };
};

export const authpwd = (eid, pwd, npwd) => {
    return dispatch => {
        dispatch(authStart());
        const authData = {
            email:eid,
            password:pwd
        }
        var authOptions = {
            method: 'POST',
            url: '/auth',
            data: authData,
            json: true
        };
        axios(authOptions)
        .then(response => {
            //const expirationDate = new Date(new Date().getTime()+response.data.expiresIn*1000);
            localStorage.setItem('token',response.data.token);
            //localStorage.setItem('expirationDate',expirationDate);
            //localStorage.setItem('userId',response.data.userId);
            //localStorage.setItem('uimage',response.data.uimage);
            //localStorage.setItem('userid',response.data.userid);
            const authData1 = {
                email:eid,
                password:pwd,
                newpassword: npwd
            };
            var authOptions1 = {
                method: 'PUT',
                url: '/user/pwd',
                data: authData1,
                json: true
            };
            axios(authOptions1)
            .then(response => {
                dispatch(authSuccess(response.data.isFirst,response.data.token, response.data.name, response.data.email,response.data._id))})
            .catch(error => {
                dispatch(authFail(error));
            });
        })
        .catch(error => {
            dispatch(authFail(error));
        });
    }
}        
export const setAuthRedirectPath = (path) => {
    return {
        type:actionTypes.SET_AUTH_REDIRECT_PATH,
        path:path
    };
};

export const authCheckState = () => {
    return dispatch => {
        const token=localStorage.getItem('token');
        if (!token) {
            dispatch(logout());
        } else {
            const expirationDate = new Date(localStorage.getItem('expirationDate'));
            if (new Date() > expirationDate) {
                //dispatch(logout());
            } else {
                dispatch(authSuccess(token,localStorage.getItem('userId')));
                dispatch(checkAuthTimeout((expirationDate.getTime() - new Date().getTime()) / 1000))
            }
        }
    }
}
